function Footer() {
    return (
        <>
            <footer
                className="rounded shadow mb-4 mt-4 footer-responsive"
                style={{ backgroundColor: '#0f172a', color: '#e2e8f0' }}
            >
                <div className="row g-3">
                    <div className="col-12 col-md-4 col-xl-6 mb-3 mb-md-0">
                        <p className="mb-0 text-center text-md-start footer-text" style={{ color: '#94a3b8', fontSize: '0.875rem' }}>© 2010-<span className="current-year">2025</span> <a
                            style={{ color: '#38bdf8', fontWeight: 500, textDecoration: 'none' }} href="https://easycripto.com.br/">JPDSS2020</a>. EasyCripto 3.3</p>
                    </div>
                    <div className="col-12 col-md-8 col-xl-6">
                        <ul className="list-inline list-group-flush list-group-borderless text-center text-md-end mb-0 footer-links">
                            <li className="list-inline-item">
                                <a href="" style={{ color: '#94a3b8', textDecoration: 'none', fontSize: '0.875rem', padding: '0.25rem 0.5rem', display: 'inline-block' }}>Sobre</a>
                            </li>
                            <li className="list-inline-item">
                                <a href="" style={{ color: '#94a3b8', textDecoration: 'none', fontSize: '0.875rem', padding: '0.25rem 0.5rem', display: 'inline-block' }}>Cursos</a>
                            </li>
                            <li className="list-inline-item">
                                <a href="https://www.amazon.com/-/pt/dp/B0FGCXKDYH/ref=tmm_pap_swatch_0?_encoding=UTF8&dib_tag=se&dib=eyJ2IjoiMSJ9.TU6KpeWSalm5uHutYX20z2djV3s70sInn0L1_Eh9xLI.c7ZAcC8APjz91Y7EdttYcDkFAE_PufSh7SlxclbV1OQ&qid=1769710931&sr=8-1" style={{ color: '#94a3b8', textDecoration: 'none', fontSize: '0.875rem', padding: '0.25rem 0.5rem', display: 'inline-block' }}>Livros</a>
                            </li>
                            <li className="list-inline-item">
                                <a href="" style={{ color: '#94a3b8', textDecoration: 'none', fontSize: '0.875rem', padding: '0.25rem 0.5rem', display: 'inline-block' }}>Contato</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default Footer;
